module.exports = __webpack_public_path__ + "static/video-poster-cc999fa7bc436dd0136dcfab4be073a5.png";